<template>
  <div class="notifications-modal-window-wrapper" v-if="show_notifications">
    <div class="notifications-header">
      <div class="notifications-title-wrapper">
        <div class="title-logo">
          <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M26 13C26 20.1797 20.1797 26 13 26C5.8203 26 0 20.1797 0 13C0 5.8203 5.8203 0 13 0C20.1797 0 26 5.8203 26 13Z" fill="#2C3236"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M13 25.4394C19.8701 25.4394 25.4394 19.8701 25.4394 13C25.4394 6.12994 19.8701 0.560647 13 0.560647C6.12994 0.560647 0.560647 6.12994 0.560647 13C0.560647 19.8701 6.12994 25.4394 13 25.4394ZM13 26C20.1797 26 26 20.1797 26 13C26 5.8203 20.1797 0 13 0C5.8203 0 0 5.8203 0 13C0 20.1797 5.8203 26 13 26Z" fill="#FF4402"/>
            <path d="M17.6383 8.36675L15.2943 10.7107C15.2344 10.7707 15.2007 10.852 15.2007 10.9368V18.3431C15.2007 18.6279 15.545 18.7705 15.7463 18.5691L18.0903 16.2252C18.1502 16.1652 18.1839 16.0839 18.1839 15.9992V8.59276C18.1839 8.308 17.8396 8.16539 17.6383 8.36675Z" fill="#FF4402"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M7.95567 10.2717C7.89682 10.2717 7.84912 10.224 7.84912 10.1651V9.99616C7.84912 9.9679 7.86035 9.9408 7.88033 9.92082C7.94745 9.8537 8.06221 9.90124 8.06221 9.99616V10.1651C8.06221 10.224 8.01451 10.2717 7.95567 10.2717Z" fill="#FF4402"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M8.80796 10.2717C8.74912 10.2717 8.70142 10.224 8.70142 10.1651V9.14381C8.70142 9.11555 8.71264 9.08845 8.73262 9.06847C8.79974 9.00135 8.9145 9.04889 8.9145 9.14381V10.1651C8.9145 10.224 8.8668 10.2717 8.80796 10.2717Z" fill="#FF4402"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M9.66026 10.2716C9.60141 10.2716 9.55371 10.2239 9.55371 10.165V8.29136C9.55371 8.2631 9.56494 8.236 9.58492 8.21602C9.65204 8.1489 9.7668 8.19644 9.7668 8.29136V10.165C9.7668 10.2239 9.7191 10.2716 9.66026 10.2716Z" fill="#FF4402"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M10.5128 10.2716C10.454 10.2716 10.4062 10.2239 10.4062 10.1651V7.39494C10.4062 7.33609 10.454 7.28839 10.5128 7.28839C10.5716 7.28839 10.6193 7.33609 10.6193 7.39494V10.1651C10.6193 10.2239 10.5716 10.2716 10.5128 10.2716Z" fill="#FF4402"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M11.3651 10.2716C11.3062 10.2716 11.2585 10.2239 11.2585 10.1651V7.39494C11.2585 7.33609 11.3062 7.28839 11.3651 7.28839C11.4239 7.28839 11.4716 7.33609 11.4716 7.39494V10.1651C11.4716 10.2239 11.4239 10.2716 11.3651 10.2716Z" fill="#FF4402"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M12.2174 10.2716C12.1585 10.2716 12.1108 10.2239 12.1108 10.1651V7.39494C12.1108 7.33609 12.1585 7.28839 12.2174 7.28839C12.2762 7.28839 12.3239 7.33609 12.3239 7.39494V10.1651C12.3239 10.2239 12.2762 10.2716 12.2174 10.2716Z" fill="#FF4402"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M13.0697 10.2716C13.0108 10.2716 12.9631 10.2239 12.9631 10.1651V7.39494C12.9631 7.33609 13.0108 7.28839 13.0697 7.28839C13.1285 7.28839 13.1762 7.33609 13.1762 7.39494V10.1651C13.1762 10.2239 13.1285 10.2716 13.0697 10.2716Z" fill="#FF4402"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M13.9222 10.2716C13.8634 10.2716 13.8157 10.2239 13.8157 10.1651V7.39494C13.8157 7.33609 13.8634 7.28839 13.9222 7.28839C13.9811 7.28839 14.0288 7.33609 14.0288 7.39494V10.1651C14.0288 10.2239 13.9811 10.2716 13.9222 10.2716Z" fill="#FF4402"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M14.7743 10.2716C14.7154 10.2716 14.6677 10.2239 14.6677 10.1651V7.39494C14.6677 7.33609 14.7154 7.28839 14.7743 7.28839C14.8331 7.28839 14.8808 7.33609 14.8808 7.39494V10.1651C14.8808 10.2239 14.8331 10.2716 14.7743 10.2716Z" fill="#FF4402"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M15.7021 9.34433C15.6349 9.41136 15.5203 9.3638 15.5203 9.26892V7.39494C15.5203 7.33609 15.568 7.28839 15.6268 7.28839C15.6857 7.28839 15.7334 7.33609 15.7334 7.39493V9.26892C15.7334 9.29721 15.7221 9.32434 15.7021 9.34433Z" fill="#FF4402"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M16.5547 8.49158C16.4876 8.5587 16.3728 8.51116 16.3728 8.41624V7.39494C16.3728 7.33609 16.4205 7.28839 16.4793 7.28839C16.5382 7.28839 16.5859 7.33609 16.5859 7.39494V8.41624C16.5859 8.4445 16.5747 8.4716 16.5547 8.49158Z" fill="#FF4402"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M17.4067 7.63923C17.3396 7.70635 17.2249 7.65881 17.2249 7.56389V7.39494C17.2249 7.33609 17.2726 7.28839 17.3314 7.28839C17.3902 7.28839 17.4379 7.33609 17.4379 7.39494V7.56389C17.4379 7.59215 17.4267 7.61925 17.4067 7.63923Z" fill="#FF4402"/>
          </svg>
        </div>
        <div class="title">
          {{ this.$t('notifications.you_have') + ' ' + this.$tc('notifications.notifications_count', $store.getters.notifications.length) + '!' }}
        </div>
      </div>

      <div class="close-button" @click="show_notifications = false; $parent.show_notifications_modal_window ? $parent.show_notifications_modal_window = false : false">
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M9.41502 7.99983L15.7068 1.70803C16.0977 1.31746 16.0977 0.683746 15.7068 0.293177C15.3159 -0.0977257 14.6829 -0.0977257 14.292 0.293177L8.00017 6.58498L1.70803 0.293177C1.31713 -0.0977257 0.68408 -0.0977257 0.293177 0.293177C-0.0977257 0.683746 -0.0977257 1.31746 0.293177 1.70803L6.58531 7.99983L0.293177 14.2916C-0.0977257 14.6822 -0.0977257 15.3159 0.293177 15.7065C0.488629 15.9016 0.744783 15.9993 1.0006 15.9993C1.25643 15.9993 1.51258 15.9016 1.70803 15.7062L8.00017 9.41435L14.292 15.7062C14.4874 15.9016 14.7436 15.9993 14.9994 15.9993C15.2552 15.9993 15.5114 15.9016 15.7068 15.7062C16.0977 15.3156 16.0977 14.6819 15.7068 14.2913L9.41502 7.99983Z" fill="#2C3236"/>
        </svg>
      </div>
    </div>

    <div class="notifications-body" v-if="$store.getters.notifications.length > 0">
      <div class="notifications-wrapper">
        <div class="notification-wrapper" v-for="(notification, index) in $store.getters.notifications" :key="index">
          <div class="notification-text">
            {{ $t(notification.text) }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NotificationsModalWindow',
  props: [
    'show'
  ],
  data () {
    return {
      show_notifications: false
    }
  },
  watch: {
    show () {
      this.show_notifications = this.show
    }
  }
}
</script>

<style lang="scss">
.notifications-modal-window-wrapper {
  position: absolute;
  right: 0;
  top: 60px;
  background: #FFFFFF;
  border-bottom: 1px solid #CFD0D1;
  border-left: 1px solid #CFD0D1;
  padding: 15px 20px;
  min-width: 500px;

  .notifications-header {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .notifications-title-wrapper {
      display: flex;
      align-items: center;

      .title-logo {
        margin-right: 10px;
      }
      .title {
        font-size: 18px;
      }
    }
    .close-button {
      cursor: pointer;
    }
  }
  .notifications-body {
    margin-top: 15px;

    .notifications-wrapper {

      .notification-wrapper {
        border-bottom: 1px solid #CFD0D1;
        padding: 10px 15px;
      }
    }
  }
}

.color-theme-dark {
  .notifications-modal-window-wrapper {
    background: #3F4448;
    border-color: #5F6467;

    .notifications-header {

      .close-button {
        svg {
          path {
            fill: #CFD0D1;
          }
        }
      }
    }
    .notifications-body {

      .notifications-wrapper {

        .notification-wrapper {
          border-bottom-color: #5F6467;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/custom_ui_components/NotificationsModalWindow.vue